"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYearsOptions = exports.getMonthsOptions = void 0;
var Localization_1 = require("../../Localization");
function getMonthsOptions() {
    var monthArray = [
        { value: 0, label: Localization_1.strings.Label_Jan },
        { value: 1, label: Localization_1.strings.Label_Feb },
        { value: 2, label: Localization_1.strings.Label_Mar },
        { value: 3, label: Localization_1.strings.Label_Apr },
        { value: 4, label: Localization_1.strings.Label_May },
        { value: 5, label: Localization_1.strings.Label_Jun },
        { value: 6, label: Localization_1.strings.Label_Jul },
        { value: 7, label: Localization_1.strings.Label_Aug },
        { value: 8, label: Localization_1.strings.Label_Sep },
        { value: 9, label: Localization_1.strings.Label_Oct },
        { value: 10, label: Localization_1.strings.Label_Nov },
        { value: 11, label: Localization_1.strings.Label_Dec },
    ];
    return monthArray;
}
exports.getMonthsOptions = getMonthsOptions;
function getYearsOptions(minYear, maxYear) {
    var currentYear = (new Date()).getFullYear();
    var startYear = currentYear - minYear;
    var endYear = currentYear + maxYear;
    var yearArray = [];
    for (var year = startYear; year <= endYear; year++) {
        yearArray.push({ value: year, label: year.toString() });
    }
    return yearArray;
}
exports.getYearsOptions = getYearsOptions;
